import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const Cont = styled.div((props)=>({
  display:'flex',
  flex:1,
  flexDirection:'column',
}))